// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:22:05

export default {
  "id": "sort-my-parking-area",
  "slug": "sort-my-parking-area",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/4ff5b5355c42484da4fc9e90a970cbe8-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/4ff5b5355c42484da4fc9e90a970cbe8/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sort: My Parking Area",
      "description": "It's time to leave the parking lot, but other cars are blocking your way! Move them in the right order to clear the path! Tight parking spaces, challenging obstacles, and unexpected challenges await you in this exciting and engaging game.",
      "instructions": "PC - Draw a course by holding LMB in the direction you want the car to go\nMobile device - Swipe your finger in the direction you want the driver to go",
      "genres": [
        "Puzzle",
        "Casual"
      ],
      "tags": [
        "car",
        "road",
        "logical",
        "sorting",
        "3d"
      ]
    },
    "zh-CN": {
      "title": "排序：我的停车场",
      "description": "是时候离开停车场了，但其他车辆挡住了你的去路！按照正确的顺序移动它们以清除道路！在这个激动人心且引人入胜的游戏中，你将面临狭小的停车位、具有挑战性的障碍和意想不到的挑战。",
      "instructions": "PC - 按住左鼠标按钮，绘制汽车行驶的方向\n移动设备 - 滑动手指以指示驾驶员行驶的方向",
      "genres": [
        "拼图",
        "休闲"
      ],
      "tags": [
        "汽车",
        "道路",
        "逻辑",
        "排序",
        "三维"
      ]
    },
    "zh-TW": {
      "title": "排序：我的停車區",
      "description": "是時候離開停車場了，但其他車輛阻擋了你的去路！以正確的順序移動它們，以清空道路！緊密的停車空間、挑戰性的障礙和意外的挑戰等待著你，在這款刺激且引人入勝的遊戲中。",
      "instructions": "PC - 持續按住左鍵並在您想要車輛行進的方向上拖曳以繪製路徑\n行動裝置 - 車輛行進的方向上輕掃手指",
      "genres": [
        "謎題",
        "休閒"
      ],
      "tags": [
        "車輛",
        "道路",
        "邏輯",
        "排序",
        "3D"
      ]
    },
    "zh-HK": {
      "title": "排序：我的停車位",
      "description": "離開停車場的時候到了，但其他車輛阻擋了你的去路！以正確的順序移動它們，以清除道路！這款刺激且引人入勝的遊戲中，等待著你的是緊湊的停車位、挑戰性的障礙和意外的挑戰！",
      "instructions": "PC - 持續按住左鍵並拖動以繪製車輛的行車路徑\n移動裝置 - 轻觸屏幕並滑動手指以指導司機行車方向",
      "genres": [
        "謎題",
        "休闲遊戲"
      ],
      "tags": [
        "車輛",
        "道路",
        "邏輯",
        "排序",
        "3D"
      ]
    },
    "ja": {
      "title": "ソート：マイ・パーキングエリア",
      "description": "駐車場を出る時刻が来ましたが、他の車が道を塞いでいます！正しい順番で移動して道を空けることができます！狭い駐車スペース、挑戦的な障害物、予期せぬ挑戦が待っているこの魅力的で楽しいゲームに挑戦してください！",
      "instructions": "PC - 左クリックボタンを押しながらカーセットしたい方向に道を描く\nモバイルデバイス - 指で運転手が行きたい方向にスワイプ",
      "genres": [
        "パズル",
        "カジュアル"
      ],
      "tags": [
        "車",
        "道",
        "論理的",
        "並べ替え",
        "3D"
      ]
    },
    "ko": {
      "title": "정렬: 내 주차공간",
      "description": "주차장을 떠나는 시간이 되었지만, 다른 차들이 길을 막고 있습니다! 올바른 순서로 차량을 이동시켜 길을 확보하세요! 촉박한 주차 공간, 도전적인 장애물, 그리고 예상치 못한 도전이 이 흥미롭고 매력적인 게임에서 기다리고 있습니다.",
      "instructions": "PC - 자동차가 가고 싶은 방향으로 마우스 왼쪽 버튼을 누른 상태에서 그리세요\n모바일 기기 - 손가락으로 원하는 방향으로 스크롤하세요",
      "genres": [
        "퍼즐",
        "캐주얼"
      ],
      "tags": [
        "차",
        "도로",
        "논리적",
        "정렬",
        "3D"
      ]
    },
    "fr": {
      "title": "Sort: Mon Parking",
      "description": "Il est temps de quitter le parking, mais d'autres voitures bloquent votre chemin ! Déplacez-les dans le bon ordre pour libérer le passage ! Des places de parking étroites, des obstacles délicats et des défis imprévus vous attendent dans ce jeu captivant et engageant.",
      "instructions": "PC - Tracez un itinéraire en maintenant le clic gauche (LMB) dans la direction où vous voulez que la voiture aille\nAppareil mobile - Faites glisser votre doigt dans la direction où vous voulez que le conducteur aille",
      "genres": [
        "Puzzle",
        "Loisir"
      ],
      "tags": [
        "car",
        "route",
        "logique",
        "tri",
        "3D"
      ]
    }
  }
};
